<template>
  <div class="moneris-payment">
    <div class="moneris-card">
      <div v-if="errorList.length > 0" class="error-list-box">
        <ul>
          <li v-for="(err, idx) in errorList" :key="idx">{{ err }}</li>
        </ul>
      </div>
      <v-layout
        row
        text-xs-left
        title
        style="margin-left: 20px; padding-top:20px;"
      >
        <v-flex xs12>
          Credit Card Information
        </v-flex>
      </v-layout>
      <v-layout row class="moneris-iframe-container">
        <iframe
          ref="monerisFrame"
          id="monerisFrame"
          :src="iframeSrc"
          :key="iframeSrc"
          class="moneris-iframe"
          allowtransparency="true"
        ></iframe>
      </v-layout>
      <v-layout
        row
        text-xs-left
        title
        style="margin-left: 20px; padding-top:20px;margin-bottom: -20px;"
      >
        <v-flex xs12>
          Billing Information
        </v-flex>
      </v-layout>
      <div class="billing-info">
        <v-layout row>
          <v-text-field
            name="ccName"
            v-model="ccPerson.ccName"
            placeholder="Name on Card"
            outlined
            dense
            hide-details
          >
          </v-text-field>
        </v-layout>
        <v-layout row>
          <v-flex xs3 mr-3>
            <v-text-field
              name="ccStreetNumber"
              placeholder="Street Number"
              maxlength="10"
              v-model="ccAddress.streetNumber"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 mx-3>
            <v-text-field
              name="ccStreetName"
              v-model="ccAddress.streetName"
              placeholder="Street Name"
              maxlength="20"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs3 ml-3>
            <v-text-field
              name="ccZipPostalCode"
              v-model="ccAddress.postalZip"
              placeholder="Postal Code"
              maxlength="10"
              required
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs6 mr-3>
            <v-text-field
              name="ccEmailAddress"
              placeholder="Email Address"
              maxlength="128"
              v-model="ccPerson.email"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 ml-3>
            <v-text-field
              name="ccPhoneNumber"
              v-model="ccPerson.phoneNumber"
              placeholder="Phone Number"
              maxlength="10"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MonerisPayment",
  props:{
    hostedTokenizationToken: {
      type: String,
      default: ""
    }
  },
  
  data() {
      const iframesrcinitializer =
      process.env.VUE_APP_MONERIS_ENV +
      "?id=" +
      this.hostedTokenizationToken +
      "&pmmsg=true;" +
      "&css_body=font-family:Roboto,sans-serif;padding:20px;" +
      "&css_input_label=font-family:Roboto,sans-serif;" +
      "&css_textbox=border:0;border-bottom:1px%20solid%20%23a2a2a2;padding:4px;outline:none;box-shadow:none;font-size:16px;font-family:Roboto,sans-serif;margin-bottom:10px;" +
      "&css_textbox_pan=width:100%;" +
      "&enable_exp=1" +
      "&css_textbox_exp=width:35%;margin-right:5%;display:inline-block;vertical-align:top;" +
      "&enable_cvd=1" +
      "&css_textbox_cvd=width:35%;display:inline-block;vertical-align:top;float:right;" +
      "&enable_exp_formatting=1" +
      "&enable_cc_formatting=1" +
      "&exp_label=Expiry Date (MM/YY)" +
      "&cvd_label=CVD" +
      "&pan_label=Card Number" +
      "&display_labels=2";

      return {
      // Credit Card Information
      ccPerson: {
        ccName: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
      },
      ccAddress: {
        streetNumber: "",
        streetName: "",
        aptSuite: "",
        city: "",
        stateProv: "",
        postalZip: "",
      },

      // Moneris Iframe and Tokenization
      monerisResponse: "",
      iframeSrc: iframesrcinitializer,
      environment: process.env.VUE_APP_MONERIS_ENV,

      // Validation Rules
      postalRequiredRule: [
        (v) => !!v || "Postal/Zip Code is required",
        (v) =>
          /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(v) ||
          /^[0-9]{5}(?:-[0-9]{4})?$/.test(v) ||
          /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(v) ||
          "Postal/Zip Code must be valid",
      ],
      streetRequiredRule: [(v) => !!v || "Street Address is required"],
      streetNumRequiredRule: [
        (v) => !!v || "Street Number is required",
        (v) =>
          /^[0-9]{1,10}$/.test(v) || "Street Number must be a valid number",
      ],
      nameRequiredRule: [(v) => !!v || "Name is required"],
      phoneNumberRequiredRule: [
        (v) => !!v || "Phone number is required",
        (v) => /^[0-9]{10}$/.test(v) || "Phone number must be 10 digits",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],

      // Field Errors
      fieldErrors: {
        ccStreetNumber: "",
        ccStreetName: "",
        ccZipPostalCode: "",
        ccEmailAddress: "",
        ccName: "",
        ccPhoneNumber: "",
      },
      monerisError: "",
      errorList: [],
    };
  },

  watch: {
    'ccPerson.ccName'(newVal) {
      if (typeof newVal === 'string' && newVal.trim().length > 0) {
        const parts = newVal.trim().split(' ');
        this.ccPerson.firstName = parts[0] || '';
        this.ccPerson.lastName = parts.length > 1 ? parts.slice(1).join(' ') : '';
      } else {
        this.ccPerson.firstName = '';
        this.ccPerson.lastName = '';
      }
    },
  },

  mounted() {
    window.addEventListener("message", this.responseMessageFromMoneris, false);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.responseMessageFromMoneris);
  },
  methods: {
    doMonerisSubmit() {
      // Validate local fields first
      this.validateAllFields();
      this.errorList = Object.values(this.fieldErrors).filter((e) => e);
      // Always call the iframe for credit card validation, even if local errors exist
      this.monerisError = "";
      const monFrameRef = this.$refs.monerisFrame.contentWindow;
      monFrameRef.postMessage("tokenize", this.environment);
    },
    responseMessageFromMoneris(e) {
      try {
        let respData;
        if (typeof e.data === "string") {
          respData = JSON.parse(e.data);
        } else {
          respData = e.data;
        }

        // Return early if responseCode is missing
        if (!respData || !('responseCode' in respData)) {
          return;
        }
        
        const statusCode = respData.responseCode[0];
        let success = false;
        switch (statusCode) {
          case "001":
            success = true;
            this.monerisError = "";
            // Only send to backend if all validations passed
            this.validateAllFields();
            this.errorList = Object.values(this.fieldErrors).filter((e) => e);
            if (this.errorList.length === 0) {
              // Emit event to parent with token and billing info
              this.$emit("moneris-success", {
                TemporaryToken: respData.dataKey,
                ccPerson: this.ccPerson,
                ccAddress: this.ccAddress,
              });
            }
            break;
          case "940":
            this.monerisError = "Invalid Profile ID.";
            break;
          case "941":
            this.monerisError = "Error generating token.";
            break;
          case "942":
            this.monerisError = "Invalid Profile ID or source URL.";
            break;
          case "943":
            this.monerisError = "Card data is invalid.";
            break;
          case "944":
            this.monerisError = "Invalid expiration date.";
            break;
          case "945":
            this.monerisError = "Invalid CVD.";
            break;
          default:
            this.monerisError = "Unknown error occurred.";
        }
        this.monerisResponse = `${e.origin} SENT - ${respData.responseCode} - ${respData.dataKey} - ${respData.errorMessage}`;
        if (!success && this.monerisError) {
          this.errorList = [
            this.monerisError,
            ...Object.values(this.fieldErrors).filter((e) => e),
          ];
        } else if (!success) {
          this.errorList = Object.values(this.fieldErrors).filter((e) => e);
        }
      } catch (err) {
        console.error("Error parsing response message", err);
      }
    },
    validateAllFields() {
      // Reset errors
      this.fieldErrors = {
        ccStreetNumber: "",
        ccStreetName: "",
        ccZipPostalCode: "",
        ccEmailAddress: "",
        ccName: "",
        ccPhoneNumber: "",
      };

      // Street Number
      for (const rule of this.streetNumRequiredRule) {
        const result = rule(this.ccAddress.streetNumber);
        if (result !== true) {
          this.fieldErrors.ccStreetNumber = result;
          break;
        }
      }
      // Street Name
      for (const rule of this.streetRequiredRule) {
        const result = rule(this.ccAddress.streetName);
        if (result !== true) {
          this.fieldErrors.ccStreetName = result;
          break;
        }
      }
      // Name
      for (const rule of this.nameRequiredRule) {
        const result = rule(this.ccPerson.ccName);
        if (result !== true) {
          this.fieldErrors.ccName = result;
          break;
        }
      }
      // Phone Number
      for (const rule of this.phoneNumberRequiredRule) {
        const result = rule(this.ccPerson.phoneNumber);
        if (result !== true) {
          this.fieldErrors.ccPhoneNumber = result;
          break;
        }
      }
      // Email
      for (const rule of this.emailRules) {
        const result = rule(this.ccPerson.email);
        if (result !== true) {
          this.fieldErrors.ccEmailAddress = result;
          break;
        }
      }
      // Postal Code
      for (const rule of this.postalRequiredRule) {
        const result = rule(this.ccAddress.postalZip);
        if (result !== true) {
          this.fieldErrors.ccZipPostalCode = result;
          break;
        }
      }
    },
  },
};
</script>

<style scoped>
.moneris-iframe-container {
  text-align: center;
  margin-bottom: -50px;
}

.billing-info {
  padding: 20px;
}

.moneris-payment {
  width: 50%;
  margin: 0 auto;
  min-width: 600px;
  background-color: #ffffff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0px;
  color: #333;
}

.moneris-card {
  text-align: center;
}

.moneris-iframe {
  width: 100%;
  height: 120px;
  border: none;
  margin: 0 auto 20px;
}

.error-list-box {
  background: #fff3f3;
  border: 1px solid #e57373;
  color: #b71c1c;
  border-radius: 8px;
  padding: 12px 20px 12px 32px;
  margin: 16px;
  font-size: 15px;
  text-align: left;
}

::v-deep .v-text-field input {
  padding-left: 5px !important;
}

::v-deep .v-text-field input::placeholder {
  color: #565656 !important;
  opacity: 1 !important; 
}
</style>
